import { styled } from "@stitches/react";
import { FlexBox } from "../../primitives";

export const Wrapper = styled(FlexBox, {
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: 20,
  width: "100%",
});
